module.exports = __webpack_public_path__ + "a42ed4914ed4835bdb603a4123b1a272.svg";